<app-crew-dashboard-ctrl
  [instructions]="globalInstructions"
  [instructionGroups]="globalInstructionGroups"
  [notifications]="notifications"
></app-crew-dashboard-ctrl>
